export default {
  info_modal: {
    button_title: 'Doorgaan',
  },
};
